// 価格スライダー
let priceRangeSlider = undefined;
let priceRangeUpdating = false;

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedApplyFilters = debounce((event) => {
      this.applyFilters(event);
    }, 400);

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    if (document.querySelector('#SortBy')) {
      document.querySelector('#SortBy').addEventListener('change', (event) => FacetFiltersForm.onChangeSortHandler(event));
    }
    if (document.querySelector('#Limit-top')) {
      document.querySelector('#Limit-top').addEventListener('change', (event) => FacetFiltersForm.onChangeLimitHandler(event));
    }
    if (document.querySelector('#Limit-bottom')) {
      document.querySelector('#Limit-bottom').addEventListener('change', (event) => FacetFiltersForm.onChangeLimitHandler(event));
    }
    // 在庫フィルター：初期バインド＋URL から選択値を復元
    const availParam = new URLSearchParams(window.location.search).get('filter.v.availability');
    document.querySelectorAll('[id^="AvailabilityFilter-"]').forEach((el) => {
      FacetFiltersForm.setupAvailabilityEl(el);
      el.addEventListener('change', FacetFiltersForm.onChangeAvailabilityHandler);
      if (availParam !== null) el.value = availParam;
    });
    // 初回ロード時にも在庫表示フィルターを適用
    FacetFiltersForm.applyAvailabilityVisibility();
    FacetFiltersForm.renderHierarchyCategoryActiveChips();

    // リアルタイムフィルタリング: チェックボックス変更時に即時反映
    this.querySelector('form').addEventListener('change', (event) => {
      if (event.target?.name === 'filter.v.availability') {
        FacetFiltersForm.syncAvailabilitySelectorsFromCheckboxes(event.target.closest('form'));
      }
      this.uncheckParentIfChecked(event);
      this.debouncedApplyFilters(event);
    });

    // Xアイコンでフィルターパネルを閉じる
    document.querySelector('#filter-close').addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector('body').classList.remove('filters_open');
      if (window.innerWidth >= 1200) {
        window.dispatchEvent(new Event('resize'));
      }
      document.querySelector('.nav_overlay').style.display = 'none';
    });

    // 閉じるボタン
    document.querySelector('#filter-reset').addEventListener('click', () => {
      document.body.classList.remove('filters_open');
      document.querySelector('.nav_overlay').style.display = 'none';
      if (window.innerWidth >= 1200) {
        window.dispatchEvent(new Event('resize'));
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    // フィルターパネルのカウントを更新（別セクションとして再フェッチ）
    FacetFiltersForm.renderFilterPanel(searchParams);

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.updatePriceRangeMax();
        //FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.updatePriceRangeMax();
    //FacetFiltersForm.renderProductCount(html);
  }

  static updatePriceRangeMax() {
    // renderProductGridContainer がDOMを更新した後に呼ぶ
    const maxEl = document.querySelector('#js-price-range-max');
    if (!maxEl) return;
    const newMax = parseFloat(maxEl.getAttribute('data-max'));
    if (!newMax || Number.isNaN(newMax)) return;

    const currentPriceRange = document.querySelector('price-range');
    if (!currentPriceRange) return;
    const oldMax = parseFloat(currentPriceRange.getAttribute('data-max-price-amount'));
    if (oldMax === newMax) return;

    currentPriceRange.setAttribute('data-max-price-amount', newMax);

    if (priceRangeSlider && priceRangeSlider.noUiSlider) {
      const currentValues = priceRangeSlider.noUiSlider.get().map(v => parseFloat(v));
      const rightHandleAtMax = currentValues[1] >= oldMax;
      priceRangeSlider.noUiSlider.updateOptions({ range: { min: 0, max: newMax } });
      if (rightHandleAtMax) {
        priceRangeUpdating = true;
        priceRangeSlider.noUiSlider.set([null, newMax]);
        priceRangeUpdating = false;
      }
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    if (document.querySelector('#SortBy')) {
      document.querySelector('#SortBy').addEventListener('change', (event) => FacetFiltersForm.onChangeSortHandler(event));
    }
    if (document.querySelector('#Limit-top')) {
      document.querySelector('#Limit-top').addEventListener('change', (event) => FacetFiltersForm.onChangeLimitHandler(event));
    }
    if (document.querySelector('#Limit-bottom')) {
      document.querySelector('#Limit-bottom').addEventListener('change', (event) => FacetFiltersForm.onChangeLimitHandler(event));
    }
    // 在庫フィルター：再バインド＋選択値を復元
    const availParamAfterRender = new URLSearchParams(window.location.search).get('filter.v.availability');
    document.querySelectorAll('[id^="AvailabilityFilter-"]').forEach((el) => {
      FacetFiltersForm.setupAvailabilityEl(el);
      el.addEventListener('change', FacetFiltersForm.onChangeAvailabilityHandler);
      el.value = availParamAfterRender !== null ? availParamAfterRender : '';
    });

    // 獲得可能ポイント数を表示
    updateLoyaltyTargets();

    // 商品画像スライダーのセット
    FacetFiltersForm.setImgSlider();
    FacetFiltersForm.renderHierarchyCategoryActiveChips();
  }

  // HACK: クラスに切り分けたい
  static setImgSlider() {
    // 不要なスクリプトタグを削除
    document.getElementById('ProductGridContainer').querySelectorAll('.prd-list').forEach(prdListEl => {
      Array.from(prdListEl.getElementsByTagName('script')).forEach(el => el.remove());
    });

    // SplideManager で遅延初期化（ビューポートに入った商品だけ Splide を起動）
    if (window.SplideManager) {
      window.SplideManager.init();
    }

    // 在庫フィルター表示制御（AJAX更新後も適用）
    FacetFiltersForm.applyAvailabilityVisibility();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    //document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  // フィルターパネルを facet-filters セクションとして再フェッチしてカウントを更新する
  static renderFilterPanel(searchParams) {
    const url = `${window.location.pathname}?section_id=facet-filters&${searchParams}`;
    const cached = FacetFiltersForm.filterData.find(d => d.url === url);
    if (cached) {
      FacetFiltersForm.updateFilterCounts(cached.html);
      return;
    }
    fetch(url)
      .then(response => response.text())
      .then(html => {
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.updateFilterCounts(html);
      });
  }

  // フェッチしたフィルターパネルHTMLを使い、各 js-filter グループのカウントを更新する
  static updateFilterCounts(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newFilters = parsed.querySelectorAll('#FacetFiltersFormMobile .js-filter');

    newFilters.forEach(newEl => {
      const idx = newEl.dataset.index;
      const current = document.querySelector(`#FacetFiltersFormMobile .js-filter[data-index="${idx}"]`);
      if (!current) return;

      // 価格レンジはスライダー状態が別管理のためスキップ
      if (current.querySelector('price-range')) return;

      const isHierarchy = !!current.querySelector('input[name="floor1"], input[name="floor2"], input[name="floor3"]');

      current.innerHTML = newEl.innerHTML;

      if (isHierarchy) {
        // 階層カテゴリーはサーバー側でchecked属性を付与しないため、URLから復元する
        const params = new URLSearchParams(window.location.search);
        ['floor1', 'floor2', 'floor3'].forEach(name => {
          const vals = params.getAll(name);
          current.querySelectorAll(`input[name="${name}"]`).forEach(cb => {
            cb.checked = vals.includes(cb.value);
          });
        });
      }
    });
  }

  // renderProductGridContainer()内で呼び出すためにstaticにしている
  static onChangeSortHandler(event) {
    const url = new URL(document.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.set('page', 1);
    location.href = url.href;
  }


  // renderProductGridContainer()内で呼び出すためにstaticにしている
  static onChangeLimitHandler(event) {
    const url = new URL(document.location.href);
    url.searchParams.set('limit', event.target.value);
    url.searchParams.set('page', 1);
    location.href = url.href;
  }

  // 在庫フィルター要素セットアップ：
  // checkbox の場合 .value をオーバーライドし、既存コードが el.value を
  // 読み書きするだけで checkbox の checked 状態と同期できるようにする。
  // 未チェック → ''、チェック済み → '1'（value 属性値）
  static setupAvailabilityEl(el) {
    if (el.type !== 'checkbox') return;
    Object.defineProperty(el, 'value', {
      get() { return this.checked ? this.getAttribute('value') : ''; },
      set(v) { this.checked = v !== '' && v === this.getAttribute('value'); },
      configurable: true,
      enumerable: true,
    });
  }

  // 在庫フィルター変更時にAJAXフィルタリングを実行
  static onChangeAvailabilityHandler(event) {
    FacetFiltersForm.syncAvailabilityCheckboxesFromSelector(event?.target?.value ?? '');
    const facetForm = document.querySelector('facet-filters-form');
    if (facetForm && facetForm.debouncedApplyFilters) {
      facetForm.debouncedApplyFilters(null);
    }
  }

  static syncAvailabilitySelectorsFromCheckboxes(form) {
    if (!form) return;
    const checked = Array.from(form.querySelectorAll('input[name="filter.v.availability"]:checked'));
    let nextValue = '';
    if (checked.length === 1) nextValue = checked[0].value;
    // 0件 or 2件以上はセレクトでは表現できないので未選択扱い
    document.querySelectorAll('[id^="AvailabilityFilter-"]').forEach((el) => {
      el.value = nextValue;
    });
  }

  static syncAvailabilityCheckboxesFromSelector(value) {
    const checkboxes = document.querySelectorAll('#FacetFiltersFormMobile input[name="filter.v.availability"]');
    if (!checkboxes.length) return;
    checkboxes.forEach((cb) => {
      cb.checked = value !== '' && cb.value === value;
    });
  }

  // 在庫フィルター表示制御：
  // filter.v.availability=0 はShopifyが「バリエーション単位で在庫なし」を返すため
  // 全バリエーション完売（product.available==false）の商品のみに絞る
  static applyAvailabilityVisibility() {
    const availEl = document.querySelector('[id^="AvailabilityFilter-"]');
    if (!availEl) return;
    const val = availEl.value;
    document.querySelectorAll('#ProductGridContainer .prd-list').forEach(function(el) {
      if (val === '0' && el.dataset.available === 'true') {
        el.style.display = 'none';
      } else {
        el.style.display = '';
      }
    });
  }

  static renderHierarchyCategoryActiveChips() {
    const params = new URLSearchParams(window.location.search);
    const selectedHierarchy = [
      ...params.getAll('floor1').map((value) => ({ name: 'floor1', value })),
      ...params.getAll('floor2').map((value) => ({ name: 'floor2', value })),
      ...params.getAll('floor3').map((value) => ({ name: 'floor3', value })),
    ];

    let chipsContainer = document.querySelector('.active-filter-chips');
    if (!chipsContainer && selectedHierarchy.length) {
      const viewContainer = document.querySelector('.view-container');
      if (viewContainer && viewContainer.parentNode) {
        chipsContainer = document.createElement('div');
        chipsContainer.className = 'active-filter-chips';
        viewContainer.insertAdjacentElement('afterend', chipsContainer);
      }
    }
    if (!chipsContainer) return;

    // Shopifyのcategory_all active chipは、階層UI（floor1/2/3）と重複/過剰になるので置き換える
    chipsContainer.querySelectorAll('[data-filter-param="filter.p.m.my_fields.category_all"]').forEach((chip) => {
      const wrapper = chip.closest('facet-remove') || chip;
      wrapper.remove();
    });
    chipsContainer.querySelectorAll('.active-filter-chip--hierarchy').forEach((chip) => {
      const wrapper = chip.closest('.active-filter-chip-wrap') || chip;
      wrapper.remove();
    });

    if (!selectedHierarchy.length) {
      if (!chipsContainer.querySelector('.active-filter-chip')) chipsContainer.remove();
      return;
    }

    // 既存チップ群の先頭に入れて、階層フィルターを目立つ位置に置く
    selectedHierarchy.reverse().forEach(({ name, value }) => {
      const wrap = document.createElement('span');
      wrap.className = 'active-filter-chip-wrap';

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'active-filter-chip active-filter-chip--hierarchy';
      button.setAttribute('data-floor-name', name);
      button.setAttribute('data-floor-value', value);
      button.innerHTML = `
        <span class="active-filter-chip__label"></span>
        <span class="active-filter-chip__remove" aria-hidden="true">&times;</span>
      `;
      button.querySelector('.active-filter-chip__label').textContent = value;

      button.addEventListener('click', () => {
        const form = document.querySelector('#FacetFiltersFormMobile');
        if (!form) return;
        const selector = `input[name="${CSS.escape(name)}"]`;
        const target = Array.from(form.querySelectorAll(selector)).find((el) => el.value === value && el.checked)
          || Array.from(form.querySelectorAll(selector)).find((el) => el.value === value);
        if (target) {
          target.checked = false;
          const facetForm = document.querySelector('facet-filters-form');
          if (facetForm) {
            facetForm.applyFilters({ target, preventDefault() {} });
          }
        }
      });

      wrap.appendChild(button);
      const chipsRow = chipsContainer.querySelector('.active-chips-row');
      if (chipsRow) {
        chipsRow.prepend(wrap);
      } else {
        chipsContainer.prepend(wrap);
      }
    });
  }

  // 下位階層チェック時、上位階層のチェックを自動解除
  uncheckParentIfChecked(event) {
    const checkbox = event.target;
    if (checkbox.type !== 'checkbox' || !checkbox.checked) return;

    const name = checkbox.name;
    if (name !== 'floor2' && name !== 'floor3') return;

    const value = checkbox.value;
    const form = checkbox.closest('form');
    const allCategoryInputs = form.querySelectorAll('input[name="filter.p.m.my_fields.category_all"]');
    const floor1Checkboxes = form.querySelectorAll('input[name="floor1"]');
    const floor2Checkboxes = form.querySelectorAll('input[name="floor2"]');

    for (const input of allCategoryInputs) {
      const parts = input.value.split(',');
      if (name === 'floor2' && parts[1] === value) {
        const parentCb = Array.from(floor1Checkboxes).find(el => el.value === parts[0] && el.checked);
        if (parentCb) parentCb.checked = false;
      }
      if (name === 'floor3' && parts[2] === value) {
        const parent2Cb = Array.from(floor2Checkboxes).find(el => el.value === parts[1] && el.checked);
        if (parent2Cb) parent2Cb.checked = false;
        const parent1Cb = Array.from(floor1Checkboxes).find(el => el.value === parts[0] && el.checked);
        if (parent1Cb) parent1Cb.checked = false;
      }
    }
  }

  applyFilters(event) {
    if (event && event.preventDefault) event.preventDefault();
    const form = (event && event.target)
      ? event.target.closest('form')
      : document.querySelector('#FacetFiltersFormMobile');
    const formData = new FormData(form);

    const searchAll = formData.getAll('filter.p.m.my_fields.category_all');
    formData.delete('filter.p.m.my_fields.category_all');

    // ++++++++++++++++++++++++++++++++++
    // 1階層目の絞り込み
    for (let values of formData.getAll('floor1')) {
      for (const data of searchAll) {
        const result = data.split(',',)
        if (result[0] === values) {
          formData.append('filter.p.m.my_fields.category_all', data)
        }
      }
    }

    // ++++++++++++++++++++++++++++++++++
    // 2階層目の絞り込み
    for (let values of formData.getAll('floor2')) {
      for (const data of searchAll) {
        const result = data.split(',',)
        if (result[1] === values) {
          formData.append('filter.p.m.my_fields.category_all', data)
        }
      }
    }

    // ++++++++++++++++++++++++++++++++++
    // 3階層目の絞り込み
    for (let values of formData.getAll('floor3')) {
      for (const data of searchAll) {
        const result = data.split(',',)
        if (result[2] === values) {
          formData.append('filter.p.m.my_fields.category_all', data)
        }
      }
    }

    // ++++++++++++++++++++++++++++++++++
    // 価格スライダー
    if (priceRangeSlider && priceRangeSlider.noUiSlider) {
      const priceRange = priceRangeSlider.noUiSlider.get();
      formData.set('filter.v.price.gte', priceRange[0]);
      // 上限が最大値（200000以上）のときは上限フィルターを送らない
      if (Number(priceRange[1]) < 200000) {
        formData.set('filter.v.price.lte', priceRange[1]);
      }
    }

    // ++++++++++++++++++++++++++++++++++
    // 並び替え
    if (document.querySelector('#SortBy')) {
      formData.set('sort_by', document.querySelector('#SortBy').value);
    }

    // ++++++++++++++++++++++++++++++++++
    // 表示件数
    if (document.querySelector('#Limit-top')) {
      formData.set('limit', document.querySelector('#Limit-top').value);
    }

    // ++++++++++++++++++++++++++++++++++
    // 在庫フィルター
    // 一覧バーのセレクトとフィルターパネルのチェックボックスを同期した上で、
    // セレクト値があれば優先、なければチェックボックス側の値をそのまま使う。
    const availEl = document.querySelector('[id^="AvailabilityFilter-"]');
    const checkedAvailabilityValues = formData.getAll('filter.v.availability');
    if (availEl && availEl.value !== '') {
      formData.delete('filter.v.availability');
      formData.set('filter.v.availability', availEl.value);
    } else if (checkedAvailabilityValues.length > 1) {
      // 在庫あり/なし両方チェックは「全件」と同義なのでパラメータを外す
      formData.delete('filter.v.availability');
    }

    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    /*
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
     */

    // ++++++++++++++++++++++++++++++++++
    // スライダー設定
    const param = (new URL(document.location)).searchParams;
    let startMin = Number.parseInt(param.get('filter.v.price.gte'));
    if (Number.isNaN(startMin)) {
      startMin = 0;
    }
    let startMax = Number.parseInt(param.get('filter.v.price.lte'));
    if (Number.isNaN(startMax)) {
      startMax = 200000;
    }

    priceRangeSlider = document.getElementById('slider');
    noUiSlider.create(priceRangeSlider, {
      start: [startMin, startMax],
      connect: true,
      range: {
        'min': 0,
        '50%': 100000,
        'max': 200000,
      },
      tooltips: [
        wNumb({ decimals: 0 }),
        {
          to: function(value) {
            return value >= 200000 ? '200000~' : wNumb({ decimals: 0 }).to(value);
          },
          from: function(value) {
            return Number(String(value).replace('~', ''));
          }
        }
      ],
      pips: {
        mode: 'range',
        density: 100,
        format: {
          to: function(value) {
            return value >= 200000 ? '200000~' : wNumb({ decimals: 0 }).to(value);
          }
        }
      },
    });

    // 価格スライダー変更時にリアルタイムフィルタリング
    priceRangeSlider.noUiSlider.on('change', () => {
      if (priceRangeUpdating) return;
      const facetForm = document.querySelector('facet-filters-form');
      if (facetForm && facetForm.debouncedApplyFilters) {
        facetForm.debouncedApplyFilters(null);
      }
    });
  }

  get maxPriceAmount() {
    const v = this.getAttribute('data-max-price-amount');
    const n = Number.parseInt(v);
    return Number.isNaN(n) ? 0 : n;
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const facetForm = document.querySelector('facet-filters-form');
      if (!facetForm) return;

      // 価格チップの場合：スライダーを全範囲にリセットして applyFilters
      if (event.currentTarget.dataset.filterParam === 'price_range') {
        if (priceRangeSlider && priceRangeSlider.noUiSlider) {
          const maxPrice = parseFloat(document.querySelector('price-range')?.getAttribute('data-max-price-amount') || 0);
          priceRangeSlider.noUiSlider.set([0, maxPrice]);
        }
        const form = document.querySelector('#FacetFiltersFormMobile');
        facetForm.applyFilters({ target: form?.querySelector('input') || form, preventDefault() {} });
        return;
      }

      const form = document.querySelector('#FacetFiltersFormMobile');
      if (!form) { facetForm.onActiveFilterClick(event); return; }

      // url_to_remove と現在URL を比較して「削除されるパラメータ」を特定する。
      // url_to_remove を直接 renderPage に渡すと section_id 混入や
      // floor* → category_all 変換バイパスが起きるため、
      // フォームを更新して applyFilters を呼ぶ方式に切り替える。
      const targetHref = event.currentTarget.href;
      const targetParams = new URLSearchParams(
        targetHref.indexOf('?') === -1 ? '' : targetHref.slice(targetHref.indexOf('?') + 1)
      );
      targetParams.delete('section_id');

      const currentParams = new URLSearchParams(window.location.search);

      let handled = false;
      for (const [key, val] of currentParams.entries()) {
        if (key === 'section_id') continue;
        if (targetParams.getAll(key).includes(val)) continue;
        // この key=val は url_to_remove に含まれていない → 削除対象

        if (key === 'filter.v.availability') {
          document.querySelectorAll('[id^="AvailabilityFilter-"]').forEach(el => { el.value = ''; });
          handled = true;
        } else {
          const checkbox = Array.from(
            form.querySelectorAll(`input[type="checkbox"][name="${key}"]`)
          ).find(el => el.value === val && el.checked);
          if (checkbox) { checkbox.checked = false; handled = true; }
        }
      }

      if (handled) {
        facetForm.applyFilters({
          target: form.querySelector('input') || form,
          preventDefault() {}
        });
      } else {
        // フォームで対応するチェックボックスが見つからない場合のフォールバック
        facetForm.onActiveFilterClick(event);
      }
    });
  }
}

customElements.define('facet-remove', FacetRemove);

class CategoryCheckbox extends HTMLElement {
  constructor() {
    super();
    this.checkIfSelected()
  }

  checkIfSelected() {
    const params = (new URL(document.location)).searchParams;
    const checkbox = this.querySelector('input');
    const selectedFloorValues = params.getAll(checkbox.name);
    checkbox.checked = selectedFloorValues.some(v => v === checkbox.value);
  }
}

customElements.define('category-checkbox', CategoryCheckbox);

// デスクトップ: フィルターパネルのスクロール追従
(function () {
  let ticking = false;

  function updateFilterPosition() {
    if (window.innerWidth < 1200) return;
    const nav = document.querySelector('nav.slide_filters');
    if (!nav) return;

    // 閉じている間は top を変更しない
    // （translateX(100%) で画面外に出るため top 変更は不要。次回オープン時に再計算）
    if (!document.body.classList.contains('filters_open')) {
      ticking = false;
      return;
    }

    // フィルター開時: .active-filter-chips の下端（商品グリッド上端）に合わせる
    // → paginationバーにパネルが重ならない
    const chips = document.querySelector('.active-filter-chips');
    let top;
    if (chips) {
      top = Math.max(0, chips.getBoundingClientRect().bottom + 12);
    } else {
      const collection = document.querySelector('#ProductGridContainer .collection');
      top = collection ? Math.max(0, collection.getBoundingClientRect().top + 10) : 0;
    }

    nav.style.top = top + 'px';
    nav.style.height = 'calc(100vh - ' + top + 'px)';
    nav.classList.toggle('is-fixed-top', top === 0);
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateFilterPosition);
      ticking = true;
    }
  }, { passive: true });

  // resize イベントでも位置を更新（フィルター開閉時に sp_utility.js が resize を発火するため）
  window.addEventListener('resize', updateFilterPosition);

  updateFilterPosition();
  window.addEventListener('load', updateFilterPosition);
})();
